import { Component } from 'react';
import { TimePicker } from '@material-ui/pickers';
import { createMuiTheme, MuiThemeProvider, TextField } from '@material-ui/core';
import { color } from 'framer-motion';

const pickerTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#3BAFDE66',
      },
    },
    MuiPickersToolbarText: {
      toolbarTxt: {
        color: '#000',
      },
    },
    MuiPickersClock: {
      clock: {
        backgroundColor: '#E5EBF0',
        border: '16px solid #006080',
        outline: '3px solid black',
        borderRadius: '50%',
        width: 254,
        height: 254,
        margin: 'auto',
        position: 'relative',
        '&:before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          backgroundImage: `
            repeating-conic-gradient(
              #000 0deg 0.5deg,
              transparent 0.5deg 6deg
            )
          `,
          backgroundSize: '100% 100%',
          zIndex: 0,
          WebkitMaskImage: 'radial-gradient(circle at center, transparent 65%, black 67%)',
          maskImage: 'radial-gradient(circle at center, transparent 65%, black 67%)',
        },
      },

      pin: {
        backgroundColor: '#000',
        width: 16,
        height: 16,
      },
    }
    ,
    MuiPickersClockNumber: {
      clockNumber: {
        fontFamily: 'Roboto',
        fontSize: 16,
        fontWeight: 700,
        color: '#000',
      },
      clockNumberSelected: {
        color: '#000'
      }
    },
    MuiPickersClockPointer: {
      pointer: {
        backgroundColor: '#000',
        borderRadius: 999,
        left: 'calc(50% - 2px)',
        width: 4,
        zIndex: 1,
      },
      thumb: {
        top: -7,
        left: -2,
        width: 8,
        height: 8,
        border: 'none',
        backgroundColor: 'red',
      },
      noPoint: {
        backgroundColor: 'red',
      }
    },
    MuiDialogActions: {
      root: {
        justifyContent: 'center',
        paddingBottom: 12,
        '& > *': {
          borderRadius: 8,
          fontSize: 16,
          fontWeight: 500,
          height: 40,
        },
        '& > :first-child': {
          backgroundColor: '#fff',
          border: '1px solid #111827',
          color: '#111827',
        },
        '& > :last-child': {
          backgroundColor: '#10B981',
          border: '1px solid #D0D5DD',
          color: '#fff',
        },
      },
    },
  },
});

const styles = {
  sizeMobile: {
    fontSize: '10pt',
  },
  input: {
    borderRadius: 8,
    borderColor: '#11182733'
  },
};
class CustomTimePicker extends Component {
  constructor() {
    super();
    this.state = {};

    this.onChange = this.onChange.bind(this);
  }

  onChange(date) {
    //eslint-disable-line no-unused-vars
    const { onTimeChange, name } = this.props;
    onTimeChange({ target: { name: name } }, date.toDate());
  }

  render() {
    const {
      name,
      value,
      fullWidth,
      style,
      placeholder,
      disabled,
      helperText,
      error,
      isDesktop,
    } = this.props;

    return (
      <MuiThemeProvider theme={pickerTheme}>
        <TimePicker
          onChange={this.onChange}
          name={name}
          value={value}
          fullWidth={fullWidth}
          style={style == null ? styles.timePicker : style}
          placeholder={placeholder}
          disabled={disabled == null ? false : disabled}
          className={isDesktop ? styles.timePicker : 'sizeMobile'}
          helperText={helperText}
          error={error}
          inputVariant="outlined"
          TextFieldComponent={(props) => (
            <TextField
              {...props}
              variant="outlined"
              style={styles.input}
              label={placeholder}
              fullWidth={fullWidth}
            />
          )}
          InputProps={{ disableUnderline: true }}
        />
      </MuiThemeProvider>
    );
  }
}

export default CustomTimePicker;
